import TripAdvisor from './tripAdvisor';

export default TripAdvisor;
